import { OrganizationNode } from '@/types/Organizations';
import { Box, Card } from '@palmetto/palmetto-components';
import { ReactNode } from 'react';

import { OrganizationSettingsCardHeader } from './OrganizationSettingsCardHeader';

interface OrganizationSettingsCardProps {
  isPhone?: boolean;
  organization?: OrganizationNode | undefined;
  onClick?: () => void;
  cardTitle: string;
  subtitle?: ReactNode;
  isLoading?: boolean;
  children?: ReactNode;
  isInherited?: boolean;
  editButtonLabel?: string;
  renderEditButton?: (button: ReactNode) => ReactNode;
  cardPadding?: string;
  error?: any;
}

export const OrganizationSettingsCard = ({
  cardTitle,
  subtitle,
  isPhone,
  organization,
  isLoading,
  children,
  isInherited,
  onClick,
  editButtonLabel,
  renderEditButton,
  cardPadding,
  error,
}: OrganizationSettingsCardProps) => {
  return (
    <Card padding={cardPadding}>
      <OrganizationSettingsCardHeader
        organization={organization}
        isPhone={isPhone}
        cardTitle={cardTitle}
        subtitle={subtitle}
        onClick={onClick}
        isInherited={isInherited}
        editButtonLabel={editButtonLabel}
        renderEditButton={renderEditButton}
      />
      {isLoading && <Box padding="0 lg lg lg">loading...</Box>}
      {!isLoading && !organization && <Box padding="0 lg lg lg">Organization not found</Box>}
      {!isLoading && organization && error && <Box padding="0 lg lg lg">{error.data.message}</Box>}
      {!isLoading && organization && !error && children}
    </Card>
  );
};
